const apiUrls = require('../../constants/apiUrls');

const justAskDetails = {
    key: 'justAskDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.JUST_ASK_BY_JOB_URL}?jobNumber=${request.workOrderNumber}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default justAskDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/justAskDetails.js